import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import FolderTreeView from "./SlideItems/FolderTreeView";
import {
  setOpenDirectory,
  loadSlideboxDirectory,
  loadSlideboxDirDataList,
  setSelectedDirectory,
  setExpandDirectory,
  getSearchDirData,
  setSelectedDirAssignUsers,
  setSelectedDirCollaborators,
  getMyWorklistsAction,
  setOpenTabAction,
  getWorklistDataAction,
  getAllOpenTabsAction,
  setSearchParams,
  setCurrentTab,
} from "../actions/slidebox-action";
import SlideboxSearch from "./SlideboxSearch";

import { Drawer, List, CssBaseline, IconButton } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { getUserDetailsAction } from "../../../actions/global-action";

const drawerWidth = 200;

const SlideboxTreeview = ({
  setSelectedDirectory,
  setExpandDirectory,
  setOpenDirectory,
  loadSlideboxDirectory,
  selectedListType,
  folderType,
  selectedFolderId,
  getSearchDirData,
  slideDirDataList,
  isListView,
  dxAccountUsers,
  loadSlideboxDirDataList,
  uploadPageLoad,
  userData,
  isModal,
  getLoggedUserDetails,
  setSelectedDirAssignUsers,
  setSelectedDirCollaborators,
  getMyWorklists,
  myWorklists,
  systemWorklists,
  newTab,
  allTabs,
  slideboxLeftSiderIsCollapse,
  setSlideboxLeftSiderIsCollapse,
  getWorklistData,
  allOpenTabsFn,
  setSearchParams,
  currentTab,
  isSearchTabActive,
  setIsSearchTabActive,
  setCurrentTab,
  isOpenedFromGroups,
  showAdvancedSearchModal,
  setShowAdvancedSearchModal,
}) => {
  const [filteredData, setFilteredData] = useState(slideDirDataList);
  const [radioButtonChecked, setRadioButtonChecked] = useState({});
  const paperRef = useRef(null);

  // The sx prop's "position: unset" on the expanded MuiDrawer-paper isn't winning
  // the CSS cascade on this build, leaving the paper on MUI's default
  // position:fixed, which then overlaps the table instead of sitting in flow.
  // Forcing it directly on the DOM node with !important is immune to any
  // stylesheet/specificity/injection-order issue.
  useLayoutEffect(() => {
    if (paperRef.current) {
      paperRef.current.style.setProperty(
        "position",
        slideboxLeftSiderIsCollapse ? "static" : "fixed",
        "important"
      );
    }
  }, [slideboxLeftSiderIsCollapse]);

  useEffect(() => {
    if (!uploadPageLoad) {
      loadSlideboxDirectory();
    } else {
    }
    getLoggedUserDetails();
    getMyWorklists();
  }, []);

  const handleDrawer = () => {
    setSlideboxLeftSiderIsCollapse(!slideboxLeftSiderIsCollapse);
  };

  useEffect(() => {
    allOpenTabsFn();
  }, []);

  return (
    <div style={{ display: "flex" }}>
      <CssBaseline />
      <Drawer
        variant="permanent"
        className={slideboxLeftSiderIsCollapse ? "slidebox-drawer-open" : ""}
        slotProps={{ paper: { ref: paperRef } }}
        sx={(theme) => ({
          width: slideboxLeftSiderIsCollapse ? drawerWidth : theme.spacing(3) + 1,
          flexShrink: 0,
          whiteSpace: "nowrap",
          "& .MuiDrawer-paper": slideboxLeftSiderIsCollapse
            ? {
                width: drawerWidth,
                left: "auto",
                top: 54,
                border: "none",
                position: "unset",
                overflowX: "scroll",
                transition: theme.transitions.create("width", {
                  easing: theme.transitions.easing.sharp,
                  duration: theme.transitions.duration.enteringScreen,
                }),
              }
            : {
                left: "auto",
                overflowX: "scroll",
                top: 54,
                zIndex: 1,
                border: "none",
                width: theme.spacing(3),
                transition: theme.transitions.create("width", {
                  easing: theme.transitions.easing.sharp,
                  duration: theme.transitions.duration.leavingScreen,
                }),
              },
        })}
      >
        <List className="tree-view-section">
          <div className="action-buttons-newUpload">
            {slideboxLeftSiderIsCollapse && (
              <div className="slidebox-search-container">
                <SlideboxSearch
                  getSearchDirData={getSearchDirData}
                  selectedListType={selectedListType}
                  loadSlideboxDirDataList={loadSlideboxDirDataList}
                  folderType={folderType}
                  selectedFolderId={selectedFolderId}
                  slideDirDataList={slideDirDataList}
                  setFilteredData={setFilteredData}
                  memberDetails={dxAccountUsers}
                  isModal={isModal}
                  filteredData={filteredData}
                  isListView={isListView}
                  setRadioButtonChecked={setRadioButtonChecked}
                  setSearchParams={setSearchParams}
                  isSearchTabActive={isSearchTabActive}
                  setIsSearchTabActive={setIsSearchTabActive}
                  showAdvancedSearchModal={showAdvancedSearchModal}
                  setShowAdvancedSearchModal={setShowAdvancedSearchModal}
                />
              </div>
            )}
            {!isModal && (
              <IconButton
                onClick={handleDrawer}
                sx={{ outline: "none !important", float: "right", width: 20, height: 20, marginTop: "10px", padding: "0 !important", fontSize: 20 }}
              >
                {slideboxLeftSiderIsCollapse ? (
                  <ChevronLeftIcon />
                ) : (
                  <ChevronRightIcon />
                )}
              </IconButton>
            )}
          </div>

          <div>
            <FolderTreeView
              newTab={newTab}
              allTabs={allTabs}
              setIsSearchTabActive={setIsSearchTabActive}
              setCurrentTab={setCurrentTab}
              setOpenDirectory={setOpenDirectory}
              setSelectedDirectory={setSelectedDirectory}
              setExpandDirectory={setExpandDirectory}
              loadSlideboxDirDataList={loadSlideboxDirDataList}
              slideboxLeftSiderIsCollapse={slideboxLeftSiderIsCollapse}
              isMovePopup={false}
              setSelectedDirCollaborators={setSelectedDirCollaborators}
              setSelectedDirAssignUsers={setSelectedDirAssignUsers}
              myWorklists={myWorklists}
              systemWorklists={systemWorklists}
              roleName={userData.roleName}
              getWorklistData={getWorklistData}
              currentTab={currentTab}
              isOpenedFromGroups={isOpenedFromGroups}
            />
          </div>
        </List>
      </Drawer>
    </div>
  );
};

const mapStateToProps = (state) => ({
  allTabs: state.SlideBox.allTabs,
  slideDirectory: state.SlideBox.folders,
  uploadPageLoad: state.SlideBox.uploadPageLoad,
  userData: state.Global.loggedUserDetails,
  ...state.SlideBox.selectedFolderData,
  ...state.SlideBox.selectedListData,
  slideDirDataList: state.SlideBox.dirDataList,
  dxAccountUsers: state.SlideBox.userList,
  myWorklists: state.SlideBox.myWorklists,
  systemWorklists: state.SlideBox.systemWorklists,
  folderType: state.SlideBox.selectedFolderData.selectedFolderType,
  selectedFolderId: state.SlideBox.selectedFolderData.selectedFolder,
  currentTab: state.SlideBox.currentTab,
});

const mapDispatchToProps = (dispatch) => ({
  newTab: (payload) => dispatch(setOpenTabAction(payload)),
  setOpenDirectory: (payload) => dispatch(setOpenDirectory(payload)),
  getMyWorklists: () => dispatch(getMyWorklistsAction()),
  setSelectedDirectory: (payload) => dispatch(setSelectedDirectory(payload)),
  setExpandDirectory: (payload) => dispatch(setExpandDirectory(payload)),
  loadSlideboxDirectory: () => dispatch(loadSlideboxDirectory()),
  loadSlideboxDirDataList: (payload) =>
    dispatch(loadSlideboxDirDataList(payload)),
  getSearchDirData: (payload) => dispatch(getSearchDirData(payload)),
  getLoggedUserDetails: () => dispatch(getUserDetailsAction()),
  setSelectedDirAssignUsers: (payload) =>
    dispatch(setSelectedDirAssignUsers(payload)),
  setSelectedDirCollaborators: (payload) =>
    dispatch(setSelectedDirCollaborators(payload)),
  getWorklistData: (payload) => dispatch(getWorklistDataAction(payload)),
  allOpenTabsFn: () => dispatch(getAllOpenTabsAction()),
  setSearchParams: (payload) => dispatch(setSearchParams(payload)),
  setCurrentTab: (payload) => dispatch(setCurrentTab(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SlideboxTreeview);
